import Vue from 'vue'
import {
    Table,
    TableColumn,
    Dialog,
    DatePicker,
    TimePicker,
    Select,
    Option,
    Input,
    Button,
    Tabs,
    TabPane,
    Form,
    FormItem,
    Radio,
    RadioGroup,
    RadioButton,
    Progress,
    Checkbox,
    CheckboxGroup,
    ColorPicker,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    ButtonGroup,
    Breadcrumb,
    BreadcrumbItem,
    Tag,
    Switch,
    Tooltip,
    Pagination
} from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(ColorPicker)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(ButtonGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tag)
Vue.use(Switch)
Vue.use(Tooltip)
Vue.use(Pagination)
